import { render, staticRenderFns } from "./TabStockAlert.vue?vue&type=template&id=9cb82ad2&scoped=true&"
import script from "./TabStockAlert.vue?vue&type=script&lang=js&"
export * from "./TabStockAlert.vue?vue&type=script&lang=js&"
import style0 from "./TabStockAlert.vue?vue&type=style&index=0&id=9cb82ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb82ad2",
  null
  
)

export default component.exports